import { render, staticRenderFns } from "./modal-multi-buttons.vue?vue&type=template&id=592904d5&scoped=true&"
import script from "./modal-multi-buttons.vue?vue&type=script&lang=js&"
export * from "./modal-multi-buttons.vue?vue&type=script&lang=js&"
import style0 from "./modal-multi-buttons.vue?vue&type=style&index=0&id=592904d5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592904d5",
  null
  
)

export default component.exports